import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from "@angular/core";

@Component({
  selector: "icn-file-analyze",
  templateUrl: "./analyze.component.html",
  styleUrls: ["./analyze.component.scss"],
})
export class FileAnalyzeComponent implements OnChanges, OnDestroy {
  @Input()
  text = "Analyzing";

  @Input()
  canRemove = true;

  @Output()
  remove = new EventEmitter();

  isFailed = 0;

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes["upload"]) {
      this.changeDetector.markForCheck();
    }
  }

  ngOnDestroy() {}

  onRemove() {
    this.remove.emit(this);
  }
}
